//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import '../../assets/css/user.css'

export default {
  name: 'login',
  data() {
    return {
      submit_loading: false,
      user: {},
    }
  },
  created() {
    window._t = this;
    console.log('document.referrer:',document.referrer);
  },
  methods: {
    on_submit: function () {

      if (!this.user.username || this.user.username.length < 4) {
        return this.$message('用户名过短,不少于4位', {
          theme: "error",
          position: "top-left",
          duration: 5000
        });
      }

      if (!this.user.password || this.user.password.length <= 6) {
        return this.$message('密码过短，不能少于6位', {
          theme: "error",
          position: "top-left",
          duration: 5000
        });
      }

      this.submit_loading = true;
      var post_data = this.user;

      this.$axios.post('/app/user/login', post_data).then((response) => {
        this.loading = false;
        var response_data = response.data;
        console.log("response_data:", response_data)

        var userinfo = response_data.user;
        var token = response_data.token;
        this.$message('登录成功，正在跳转', {
          theme: "normal",
          position: "top-left",
          duration: 5000
        });

        this.$store.commit('login', {
          'userinfo': userinfo,
          'token': token
        });
        this.$router.push('/');

      }).catch( (error)=> {
        console.log('error:', error);
        this.submit_loading = false;

      });
      return false;
    }
  }

}
